import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { Card, Empty } from "../../dashboard/primitives";
import Kanban from "../../dashboard/Kanban";
import { SkeletonList, SkeletonRow } from "../../components/Skeleton";

const ProjectTasks = () => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "projects", projectId), (snap) => {
      setProject(snap.exists() ? { id: snap.id, ...snap.data() } : null);
      setLoaded(true);
    });
    return unsub;
  }, [projectId]);

  if (!loaded)
    return (
      <Card title="Tasks">
        <SkeletonList count={4} ariaLabel="Loading tasks">
          <SkeletonRow cols={3} widths={["1fr", "100px", "120px"]} />
        </SkeletonList>
      </Card>
    );
  if (!project) return <Card title="Tasks"><Empty>Project not found</Empty></Card>;

  return (
    <Card
      title={`${project.title} · Tasks`}
      action={<Link to="/admin/projects" className="fw-btn fw-btn--ghost">← All projects</Link>}
    >
      <Kanban projectId={projectId} readOnly={false} />
    </Card>
  );
};

export default ProjectTasks;
